"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectLocationLinkDisplayComponent = exports.DefaultHiddenProjectLocation = exports.DefaultNoneProjectLocation = exports.ProjectLocationPlaceholderStyle = void 0;
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var SiteUrlsContext_1 = require("../urls/SiteUrlsContext");
/** This matches the HiddenUserStyle in VizPortalClient */
exports.ProjectLocationPlaceholderStyle = {
    color: '#BFBFBF',
    fontWeight: 'inherit',
    fontStyle: 'italic',
};
function DefaultNoneProjectLocation() {
    return React.createElement("span", { style: exports.ProjectLocationPlaceholderStyle }, Localize_1.Messages.None());
}
exports.DefaultNoneProjectLocation = DefaultNoneProjectLocation;
function DefaultHiddenProjectLocation() {
    return (React.createElement("span", { style: exports.ProjectLocationPlaceholderStyle }, Localize_1.Messages.PermissionsRequired()));
}
exports.DefaultHiddenProjectLocation = DefaultHiddenProjectLocation;
function ProjectLocationLinkDisplayComponent(props) {
    var urls = React.useContext(SiteUrlsContext_1.SiteUrlsContext);
    if (!props.location || !props.locationId) {
        return props.noneLocationElement || React.createElement(DefaultNoneProjectLocation, null);
    }
    // TODO: Add obfuscation case
    // Story 1338824: [DBs in Projects][UI] Integrate location column cell formatters with webclient api responses
    else {
        var url = urls.projectUrl(props.locationId);
        var path = urls.projectPath(props.location);
        return (React.createElement(props.linkComponent, { url: url, pathname: path, id: props.locationId }));
    }
}
exports.ProjectLocationLinkDisplayComponent = ProjectLocationLinkDisplayComponent;
//# sourceMappingURL=ProjectLocationDisplayComponent.js.map